import React from 'react';

import { AlertCircle } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const UploadFileTypeError = ({ reloadRecording, questionType }) => {
  const isVideo =
    questionType === 'screen_recording' || questionType === 'webcam_recording';
  const exampleFileTypes = () => {
    return isVideo ? 'mp4, mov, avi' : 'mp3, wav, wma';
  };

  return (
    <div className="d-f ai-c jc-c RecordingQuestion--uploadFileTypeError">
      <Text
        className="c-error d-f ai-c mr-4"
        variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
      >
        <AlertCircle size={17} className="mr-4" />
        {t('practice.repeatability.upload_type_error')}
      </Text>
      <button
        type="button"
        className="ButtonLink"
        onClick={reloadRecording}
        onKeyDown={e => e.key === 'Enter' && reloadRecording}
      >
        <Text variant={TEXT_VARIANTS.BODY_LINK}>
          {t('practice.repeatability.upload_type_error_try_again')}{' '}
          {`(i.e. ${exampleFileTypes()})`}
        </Text>
      </button>
    </div>
  );
};

export default UploadFileTypeError;
